import React from 'react';
import PropTypes from 'prop-types';
import ContractFileList from '~components/contract-file-list';
export default function RecordLandlord(props) {
  const { t, fileArray, belongTo } = props;

  return (
    <div className="record-landlord">
      <h3 className="record-landlord__files-title">
        {belongTo === 'property'
          ? t('cms:cms.property.record_landlord.property_level.title')
          : t('cms:cms.property.record_landlord.landlord_level.title')}
      </h3>
      <Choose>
        <When condition={fileArray.length === 0}>
          <p className="record-landlord__blank-tip">
            {t(
              belongTo === 'property'
                ? 'cms:cms.property.record_landlord.property_level.blank'
                : 'cms:cms.property.record_landlord.landlord_level.blank',
            )}
            .
          </p>
        </When>
        <Otherwise>
          <div className="record-landlord__files-wrap">
            <ContractFileList files={fileArray} />
          </div>
        </Otherwise>
      </Choose>
    </div>
  );
}

RecordLandlord.propTypes = {
  t: PropTypes.func.isRequired,
  fileArray: PropTypes.array.isRequired,
  belongTo: PropTypes.string.isRequired,
};

RecordLandlord.defaultProps = {
  t: () => {},
  fileArray: [],
  belongTo: '',
};
